import { queryOptions } from "@tanstack/react-query";
import z from "zod";
import {
  getCurrentUser,
  getWechatReviewSubscriptionStatus,
  setUsername,
} from "@/lib/api/generated/endpoints/auth/auth";
import { getMyPoints } from "@/lib/api/generated/endpoints/review/review";
import type { AuthenticatedUser } from "@/lib/api/generated/model";

export type CurrentUser = AuthenticatedUser;

export const setUsernameSchema = z.object({
  name: z
    .string()
    .min(2, "用户名至少两个字")
    .max(16, "用户名最多16个字")
    .regex(
      /^[\u4E00-\u9FA5\w\-@!#$%^&*()+[\]{}\\|/?.>,<]+$/,
      "用户名只能包含中文、英文、数字、- 和 _",
    ),
});

export const userQueryOptions = queryOptions({
  queryKey: ["user"],
  queryFn: () =>
    getCurrentUser()
      .then((response) => response.user ?? null)
      .catch(() => null),
});

export const userPointsQueryOptions = queryOptions({
  queryKey: ["user", "points"],
  queryFn: () => getMyPoints().then((response) => response.points),
});

export { getWechatReviewSubscriptionStatus, setUsername };
